import { FC, useState } from 'react';
import DataRow from '@/libs/antd/components/DataRow';
import FleetModal from '@/libs/antd/components/Modal';
import FleetTitle from '@/libs/antd/components/Title';
import { ProspectBankStatement } from '@/libs/fleet-api/services/types';
import { useModals } from './ModalProvider';
import dayjs from 'dayjs';

export type BankStatementModalState = null | {
	bankStatement: ProspectBankStatement;
};

export type BankStatementModalProps = {
	modal: BankStatementModalState;
	onClose: () => void;
};

const BankStatementModal: FC<BankStatementModalProps> = ({
	modal,
	onClose,
}) => {
	const { openPreviewModal } = useModals();
	const {
		accountNo,
		bankStatementPeriod,
		// totalCredit,
		// totalDebit,
		// averageBalance,
		bankName,
		accountType,
		bankStatementFile,
	} = modal?.bankStatement ?? {};

	return (
		<FleetModal
			open={Boolean(modal)}
			width={940}
			cancelText="BACK"
			buttonPosition="end"
			closable={false}
			okButtonProps={{
				hidden: true,
			}}
			onCancel={() => onClose?.()}
		>
			<FleetTitle>Detil Rekening Bank</FleetTitle>
			<DataRow
				items={[
					[
						['Jenis Rekening Bank', accountType?.value],
						['Bank Name', bankName?.value],
					],
					[
						['Account Number', accountNo],
						['Periode', dayjs(bankStatementPeriod).format('MM/YYYY')],
					],

					[
						[
							'View Dokumen',
							<a
								href="#"
								className="trigger-popup"
								onClick={(e) => {
									e.preventDefault();
									if (!bankStatementFile) return;
									openPreviewModal({
										name: bankStatementFile.name,
										url: bankStatementFile.url,
										id: bankStatementFile.id as unknown as number,
									});
								}}
							>
								View Dokumen
							</a>,
						],
					],
				]}
				style={{
					marginBottom: 20,
				}}
			/>
		</FleetModal>
	);
};

export default BankStatementModal;

export const useBankStatementModal = () => {
	return useState<BankStatementModalState>(null);
};
